// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * DOCX export styles - includes:
 * - Custom editor theming overrides
 *
 * Loaded from docx.css entry point - used only for DOCX export generation.
 */

.ck {
  --ck-color-link-default: var(--t-colors-blue-300);
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/editor-styles.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,iDAAiD;AACnD","sourcesContent":["/**\n * DOCX export styles - includes:\n * - Custom editor theming overrides\n *\n * Loaded from docx.css entry point - used only for DOCX export generation.\n */\n\n.ck {\n  --ck-color-link-default: var(--t-colors-blue-300);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
